// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const merge = require('lodash/object/merge');
const {
    BROKER_TEMPORARY_SPC_INDEXES,
    BROKER_MAIN_STOCKS_FALLERS,
    BROKER_MAIN_STOCKS_RISERS,
    BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS,
    BROKER_MAIN_STOCKS_BY_VOLUME,
    BROKER_MAIN_STOCKS_BY_PERCENTAGE,
    BROKER_TICKER_SCREEN
} = require('constants/index');

const setStockMarket = (market) => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_MARKET_CHANGED,
    payload: { market }
})

const setPreoviousPage = (prevPage) => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_SET_PREVIOUS_PAGE,
    payload: { prevPage }
})

const resetStocksMarket = () => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_RESET_STOCKS_MARKET
});

const setShowMoreSelectedTab = (tab) => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_SET_SHOW_MORE_SELECTED_TAB,
    payload: { tab }
})

const resetShowMoreSelectedTab = () => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_RESET_SHOW_MORE_SELECTED_TAB
});

const setStockMarketDefault = (defaultIndex) => (dispatch, getState) => {
    const indexValue = getState().brokerTodaysMainStocks;
    const selectMarket = indexValue.get('selectedMarket');
    if (selectMarket) {
        return dispatch(setStockMarket(selectMarket));
    } else {
        return dispatch(setStockMarket(defaultIndex));
    }
}

const requestIndexes = () => ({ type: actionTypes.BROKER_EXCHANGE_INDEXES_REQUEST })

const requestIndexesSuccess = (data) => ({
    type: actionTypes.BROKER_EXCHANGE_INDEXES_SUCCESS,
    payload: { data }
})

const requestIndexesFailure = (error) => ({
    type: actionTypes.BROKER_EXCHANGE_INDEXES_FAILURE,
    payload: { error }
})

const requestIndexesPlayers = () => ({ type: actionTypes.BROKER_EXCHANGE_INDEXES_PLAYERS_REQUEST })

const requestIndexesPlayersSuccess = (data) => ({
    type: actionTypes.BROKER_EXCHANGE_INDEXES_PLAYERS_SUCCESS,
    payload: { data }
})

const requestIndexesPlayersFailure = (error) => ({
    type: actionTypes.BROKER_EXCHANGE_INDEXES_PLAYERS_FAILURE,
    payload: { error }
})

const requestStocksByIndex = (selectedMarket) => ({ type: actionTypes.BROKER_STOCKS_BY_INDEX_REQUEST, payload: {selectedMarket} })

const requestStocksByIndexSuccess = (selectedMarket, data) => ({
    type: actionTypes.BROKER_STOCKS_BY_INDEX_SUCCESS,
    payload: { data, selectedMarket }
})

const requestStocksByIndexFailure = (selectedMarket, error) => ({
    type: actionTypes.BROKER_STOCKS_BY_INDEX_FAILURE,
    payload: { error, selectedMarket }
})

// @hardcoded
const getTickersIndexes = () => (dispatch) => {
    const requestData = {
        query: {
            pageNum: 0,
            pageSize: 8,
            spcSymbol: BROKER_TEMPORARY_SPC_INDEXES, // @hardcoded Must be changed to BROKER_TICKER_SPC_SYMBOL,
            exchangeId: 0,
            screen: BROKER_TICKER_SCREEN
        }
    };
    dispatch(requestIndexes());
    return APIGet(dispatch, apiURLBuilder.getURL('exchangeIndexes') , requestData)
        .then((response) => {
            dispatch(requestIndexesSuccess(response))
            dispatch(setStockMarketDefault());
        })
        .catch((response) => dispatch(requestIndexesFailure(response.error)))
}

const getDefaultMarketIndexSuccess = (response) => ({
    type: actionTypes.BROKER_GET_DEFAULT_CONFIG_SUCCESS,
    payload: { response }
});

const getDefaultMarketIndexFailure = (error) => ({
    type: actionTypes.BROKER_GET_DEFAULT_CONFIG_FAILURE,
    payload: { error }
});

const requestGetDefaultConfig = () => ({ type: actionTypes.BROKER_GET_DEFAULT_CONFIG_REQUEST })

const getIndexesAggregationPlayers = () => (dispatch, getState) => {
    const brokerDefaultStockConfig = getState().brokerTickerExchangeIndexes;
    const defaultExchangeId = brokerDefaultStockConfig.get('defaultExchangeId');
    const indexesAggregationPlayers = brokerDefaultStockConfig.get('indexesAggregationPlayers')
    const requestData = {
        query: {
            pageNum: 0,
            pageSize: 8,
            spcSymbol: indexesAggregationPlayers,
            exchangeId: defaultExchangeId,
            screen: BROKER_TICKER_SCREEN
        }
    };

    dispatch(requestIndexesPlayers())
    return APIGet(dispatch, apiURLBuilder.getURL('exchangeIndexes') , requestData)
        .then((response) => {
            dispatch(requestIndexesPlayersSuccess(response));
        })
        .catch((response) => dispatch(requestIndexesPlayersFailure(response.error)))
}


const getIndexes = () => (dispatch, getState) => {
    //Get SPC_INDEX from an API
    dispatch(requestGetDefaultConfig());
    APIGet(dispatch, apiURLBuilder.getURL('getDefaultMarketConfig'))
    .then(response => {
        dispatch(getDefaultMarketIndexSuccess(response));
        const brokerDefaultStockConfig = getState().brokerTickerExchangeIndexes;
        const indexesAggregation = brokerDefaultStockConfig.get('indexesAggregation');
        const defaultExchangeId = brokerDefaultStockConfig.get('defaultExchangeId');
        const defaultSpcSymbol =  brokerDefaultStockConfig.get('defaultSpcSymbol');

        const requestData = {
            query: {
                pageNum: 0,
                pageSize: 8,
                spcSymbol: indexesAggregation,
                exchangeId: defaultExchangeId,
                screen: BROKER_TICKER_SCREEN
            }
        };

        dispatch(getIndexesAggregationPlayers())
        dispatch(requestIndexes());
        return APIGet(dispatch, apiURLBuilder.getURL('exchangeIndexes') , requestData)
            .then((response) => {
                dispatch(requestIndexesSuccess(response));
                dispatch(setStockMarketDefault(defaultSpcSymbol));
            })
            .catch((response) => dispatch(requestIndexesFailure(response.error)));
    })
    .catch((response) => dispatch(getDefaultMarketIndexFailure(response.error)));
}

const getStocksByIndex = (params = {}) => (dispatch) => {
    const requestData = {
        query: {
            pageNum: 0,
            pageSize: 0,
            spcSymbol: params.spcSymbol,
            exchangeId: params.exchangeId,
            screen: BROKER_TICKER_SCREEN
        }
    };
    dispatch(requestStocksByIndex(params.selectedMarket));
    return APIGet(dispatch, apiURLBuilder.getURL('exchangeIndexes') , requestData)
        .then((response) => {
            dispatch(requestStocksByIndexSuccess(params.selectedMarket, response));
        })
        .catch((response) => dispatch(requestStocksByIndexFailure(params.selectedMarket, response.error)))
}

const requestRaisersFallersRequest = () => ({ type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_REQUEST })

const requestRisersFallersSuccess = (marketName, data) => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_SUCCESS,
    payload: {
        marketName,
        byVolume: data.byVolume,
        byPercentage: data.byPercentage
    }
})

const requestRisersFallersFailure = (error) => ({
    type: actionTypes.BROKER_TODAYS_MAIN_STOCKS_FAILURE,
    payload: { error }
})

const createRequestData = (baseRequestData, riseFall, selectBy) => {
    return merge({}, baseRequestData, {query: {riseFall: riseFall, selectBy: selectBy}})
}


const getRisersAndFallers = (params = {}) => (dispatch) => {
    const {exchangeId, spcSymbol, market, resultsAmount, byVolume, byPercentage } = params;
    dispatch(setStockMarket(market));
    const baseRequestData = {
        query: {
            spcSymbol,
            exchangeId,
            pageNum: 1,
            pageSize: resultsAmount || BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS,
            topStocks: resultsAmount || BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS
        }
    };

    let requests = [];
    let newRequest;

    if ( byVolume.risers ){
        newRequest = createRequestData(baseRequestData, BROKER_MAIN_STOCKS_RISERS, BROKER_MAIN_STOCKS_BY_VOLUME);
        requests.push(APIGet(dispatch, apiURLBuilder.getURL('risersFallers') , newRequest).then(function(r){
            return { byVolume: { risers: r } };
        }));
    }

    if ( byVolume.fallers ){
        newRequest = createRequestData(baseRequestData, BROKER_MAIN_STOCKS_FALLERS, BROKER_MAIN_STOCKS_BY_VOLUME);
        requests.push(APIGet(dispatch, apiURLBuilder.getURL('risersFallers') , newRequest).then(function(r){
            return { byVolume: { fallers: r } };
        }));
    }

    if ( byPercentage.risers ){
        newRequest = createRequestData(baseRequestData, BROKER_MAIN_STOCKS_RISERS, BROKER_MAIN_STOCKS_BY_PERCENTAGE);
        requests.push(APIGet(dispatch, apiURLBuilder.getURL('risersFallers') , newRequest).then(function(r){
            return { byPercentage: { risers: r } };
        }));
    }

    if ( byPercentage.fallers ){
        newRequest = createRequestData(baseRequestData, BROKER_MAIN_STOCKS_FALLERS, BROKER_MAIN_STOCKS_BY_PERCENTAGE);
        requests.push(APIGet(dispatch, apiURLBuilder.getURL('risersFallers') , newRequest).then(function(r){
            return { byPercentage: { fallers: r } };
        }));
    }

    dispatch(requestRaisersFallersRequest());
    return Promise.all(requests)
        .then((responses) => {
            // (Andres): Let's transform something like
            // [
            //      {
            //          byVolume: { risers: [] }
            //      },
            //      {
            //          byVolume: { fallers: [] }
            //      }
            // ]
            // into something like
            // {
            //      byVolume: { risers: [], fallers: [] }
            // }

            let data = {};
            responses.forEach(item => {
                merge(data, item);
            });
            dispatch(requestRisersFallersSuccess(market, data));
        })
        .catch((response) => {
            return dispatch(requestRisersFallersFailure(response.error));
        })
}

module.exports = {
    getRisersAndFallers,
    getTickersIndexes,
    getIndexes,
    getStocksByIndex,
    setStockMarket,
    resetStocksMarket,
    setShowMoreSelectedTab,
    setPreoviousPage,
    resetShowMoreSelectedTab
}
